import Vue from 'vue'

/**
 * Controle dos timeouts para apagar o status de digitando após receber o evento. Essa lógica é necessária
 * porque nós não vamos receber um evento de "parou de digitar".
 */
const timeoutDigitando = {}

export const Flash = {
    namespaced: true,
    state: () => {
        return {
            /**
             * A ideia da palavra "flash" é indicar algo curto, temporário, passageiro. Os flashes armazenam dados como
             * "usuário digitando" ou o "usuário gravando áudio". Como nós mostramos essa informação em cada sala na UI,
             * faz sentido usar um mapa de {"id_sala": [lista_de_flash]}
             */
            flashPorSala: {},
        }
    },
    getters: {
        encontrarPorSala: state => id => {
            let flash = state.flashPorSala[id]
            if (flash && flash.length > 0) {
                return 'digitando'
            }
        },
    },
    mutations: {
        adicionarFlash(state, { chave, nome, valor }) {
            if (state.flashPorSala[chave]) {
                state.flashPorSala[chave].push({ nome, valor })
            } else {
                Vue.set(state.flashPorSala, chave, [{ nome, valor }])
            }
        },
        removerFlash(state, { chave, nome, valor_id }) {
            if (!state.flashPorSala[chave]) return

            state.flashPorSala[chave] = state.flashPorSala[chave].filter(flash => {
                return !((!nome || flash.nome == nome) && flash.valor.id == valor_id)
            })
        },
    },
    actions: {
        /**
         * Atualiza o flash da sala para "digitando" e limpa essa informação alguns segundos depois.
         */
        async digitando({ commit }, dados) {
            let chaveTimeout = dados['autor'] + dados['mensageiro_id']
            let chaveFlash = dados.mensageiro_type + ':' + dados.mensageiro_id

            commit('adicionarFlash', {
                chave: chaveFlash,
                nome: 'digitando',
                valor: { id: dados.autor, nome: dados.autor_nome },
            })

            if (timeoutDigitando[chaveTimeout]) {
                clearTimeout(timeoutDigitando[chaveTimeout])
            }

            timeoutDigitando[chaveTimeout] = setTimeout(() => {
                commit('removerFlash', { chave: chaveFlash, nome: 'digitando', valor_id: dados.autor })
            }, 3000)
        },
    },
}
